/**
 * Заголовок секции: один размер на всех страницах вместо шести разных.
 * Слева по умолчанию — в B2B-страницах так читается лучше, чем по центру.
 */
export default function SectionTitle({
  eyebrow,
  title,
  description,
  align = "left",
  className = "",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  className?: string;
}) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";

  return (
    <div className={`mb-6 max-w-3xl md:mb-8 ${alignClass} ${className}`}>
      {eyebrow ? (
        <p className="mb-2 text-xs uppercase tracking-wider text-white/40">{eyebrow}</p>
      ) : null}
      <h2 className="text-xl font-semibold tracking-tight text-white md:text-2xl">{title}</h2>
      {description ? (
        <p className="mt-2 text-sm leading-relaxed text-white/60">{description}</p>
      ) : null}
    </div>
  );
}
